let isEnabled = false

function initMetaPixel($config) {
  if (isEnabled || typeof window === 'undefined' || !$config.metaPixelId) return
  isEnabled = true

  const pixelId = $config.metaPixelId

  // Stub fbq queue before script loads (same pattern as Meta's snippet)
  const f = window
  const b = document
  const e = 'script'
  const v = 'https://connect.facebook.net/en_US/fbevents.js'
  if (f.fbq) return
  const n = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []
  const t = b.createElement(e)
  t.async = true
  t.src = v
  const s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

export default function ({ app, $consent, $config }, inject) {
  if (typeof window === 'undefined') {
    inject('fbq', () => {})
    return
  }

  inject('fbq', (method, ...args) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq(method, ...args)
    }
  })

  if ($consent.cookies.marketing) {
    initMetaPixel($config)
  } else {
    if (!app.mixins) app.mixins = []
    app.mixins.push({
      watch: {
        '$consent.cookies.marketing': {
          handler(newVal) {
            if (newVal) {
              initMetaPixel(this.$config)
            }
          },
          immediate: true,
        },
      },
    })
  }
}
